<template>
  <ion-modal :is-open="isOpen" :initial-breakpoint="0.85" :breakpoints="[0, 0.85, 1]"
    @willDismiss="hideModal" class="link-menu-modal">
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-title>Pilihan Menu</ion-title>
        <ion-buttons slot="end">
          <ion-button @click="hideModal" color="medium">Batal</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding-horizontal">
      <div class="parent-info-card" v-if="parentProduct">
        <img :src="parentProduct.photo || 'https://res.cloudinary.com/dxcleuxwe/image/upload/v1758687442/placeholder/no-product-image_v7tdrr.png'" class="parent-img" />
        <div class="parent-text">
          <h3>{{ parentProduct.name }}</h3>
          <p class="parent-price">{{ formatter.format(parentProduct.price) }}</p>
        </div>
      </div>

      <div v-for="group in activeGroups" :key="group.linkmenu_id" class="group-container">
        <div class="group-header">
          <span class="group-name">{{ group.name }}</span>
          <span class="group-badge">{{ group.is_multiplechoice === 0 ? 'Pilih salah satu' : 'Bisa pilih lebih dari satu' }}</span>
        </div>

        <div class="options-list">
          <div v-for="detail in group.link_menu_detail" :key="detail.linkmenu_detail_id" 
            class="option-card"
            :class="{ 
              'selected': isSelected(group.linkmenu_id, detail.product_detail_fkid, group.is_multiplechoice) 
            }"
            @click="selectOption(group.linkmenu_id, detail.product_detail_fkid, group.is_multiplechoice)">
            
            <div class="option-left">
              <img :src="resolveProduct(detail.product_detail_fkid)?.photo || 'https://res.cloudinary.com/dxcleuxwe/image/upload/v1758687442/placeholder/no-product-image_v7tdrr.png'" class="option-img" />
              <div class="option-info">
                <span class="option-name">{{ resolveProduct(detail.product_detail_fkid)?.name }}</span>
                <span class="option-price">
                  {{ detail.price_add > 0 ? `+ ${formatter.format(detail.price_add)}` : 'Gratis' }}
                </span>
              </div>
            </div>

            <div class="option-right">
              <div v-if="group.is_multiplechoice === 0" class="radio-indicator">
                <div class="radio-inner" v-show="isSelected(group.linkmenu_id, detail.product_detail_fkid, group.is_multiplechoice)"></div>
              </div>
              <div v-else class="checkbox-indicator">
                <ion-icon :icon="checkmarkOutline" v-show="isSelected(group.linkmenu_id, detail.product_detail_fkid, group.is_multiplechoice)"></ion-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ion-content>

    <div class="ion-no-border modern-footer">
      <div class="button-group">
        <ion-button expand="block" class="btn-main" @click="confirmSelection">
          Tambah ke Keranjang
        </ion-button>
      </div>
    </div>
  </ion-modal>
</template>

<script>
import {
  IonModal, IonHeader, IonToolbar, IonTitle, IonContent,
  IonButton, IonButtons, IonIcon, alertController
} from '@ionic/vue';
import { checkmarkOutline } from 'ionicons/icons';

export default {
  name: "LinkMenuDialog",
  props: ["isOpen", "parentProduct", "linkMenus", "categories", "topPickItems"],
  components: {
    IonModal, IonHeader, IonToolbar, IonTitle, IonContent,
    IonButton, IonButtons, IonIcon
  },
  setup() {
    return { checkmarkOutline };
  },
  data() {
    return {
      formatter: new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }),
      selectedOptions: {}, // key: linkmenu_id, value: detail_id or array of detail_ids
    };
  },
  computed: {
    activeGroups() {
      if (!this.parentProduct || !this.linkMenus) return [];
      // Filter link menu groups that belong to the active parent detail id
      // and ensure only valid products are included in the options list.
      return this.linkMenus
        .filter(
          group => group.product_detail_fkid == this.parentProduct.product_detail_id &&
                   group.link_menu_detail &&
                   group.link_menu_detail.length > 0
        )
        .map(group => {
          const validDetails = group.link_menu_detail.filter(
            detail => !!this.resolveProduct(detail.product_detail_fkid)
          );
          return {
            ...group,
            link_menu_detail: validDetails
          };
        })
        .filter(group => group.link_menu_detail.length > 0);
    }
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.initializeSelections();
      }
    }
  },
  methods: {
    hideModal() {
      this.$emit("close");
    },
    resolveProduct(detailId) {
      if (!this.categories) return null;
      // Search in main categories
      for (const cat of this.categories) {
        if (!cat.products) continue;
        const prod = cat.products.find(p => p.product_detail_id == detailId);
        if (prod) return prod;
      }
      // Search in top pick items
      if (this.topPickItems) {
        const foundTop = this.topPickItems.find(p => p.product_detail_id == detailId);
        if (foundTop) return foundTop;
      }
      return null;
    },
    initializeSelections() {
      const selections = {};
      this.activeGroups.forEach(group => {
        if (group.is_multiplechoice === 0) {
          // Single choice: start with null so no option is pre-selected
          selections[group.linkmenu_id] = null;
        } else {
          // Multiple choice
          selections[group.linkmenu_id] = [];
        }
      });
      this.selectedOptions = selections;
    },
    isSelected(linkmenuId, detailFkid, isMultiplechoice) {
      const val = this.selectedOptions[linkmenuId];
      if (isMultiplechoice === 0) {
        return val === detailFkid;
      } else {
        return Array.isArray(val) && val.includes(detailFkid);
      }
    },
    selectOption(linkmenuId, detailFkid, isMultiplechoice) {
      if (isMultiplechoice === 0) {
        this.selectedOptions[linkmenuId] = detailFkid;
      } else {
        const current = this.selectedOptions[linkmenuId] || [];
        const index = current.indexOf(detailFkid);
        if (index > -1) {
          current.splice(index, 1);
        } else {
          current.push(detailFkid);
        }
        this.selectedOptions[linkmenuId] = [...current];
      }
    },
    async confirmSelection() {
      // Validation: Check if all single-choice groups have a selection
      for (const group of this.activeGroups) {
        if (group.is_multiplechoice === 0) {
          const detailFkid = this.selectedOptions[group.linkmenu_id];
          if (!detailFkid) {
            const alert = await alertController.create({
              header: 'Pilihan Belum Lengkap',
              message: `Silakan pilih salah satu opsi untuk "${group.name}".`,
              buttons: ['OK']
            });
            await alert.present();
            return;
          }
        }
      }

      const selectedGroups = [];
      this.activeGroups.forEach(group => {
        const groupSelection = {
          linkmenu_id: group.linkmenu_id,
          product_fkid: group.product_fkid,
          link_menu_detail: []
        };

        if (group.is_multiplechoice === 0) {
          const detailFkid = this.selectedOptions[group.linkmenu_id];
          if (detailFkid) {
            const detail = group.link_menu_detail.find(d => d.product_detail_fkid == detailFkid);
            const resolved = this.resolveProduct(detailFkid);
            groupSelection.link_menu_detail.push({
              linkmenu_detail_id: detail ? detail.linkmenu_detail_id : 0,
              product_detail_fkid: detailFkid,
              price_add: detail ? detail.price_add : 0,
              product_name: resolved ? resolved.name : 'Tambahan',
              photo: resolved ? resolved.photo : "",
              tax: resolved && resolved.tax ? resolved.tax.filter(t => t.tax_status === "permanent") : []
            });
          }
        } else {
          const detailFkids = this.selectedOptions[group.linkmenu_id] || [];
          detailFkids.forEach(detailFkid => {
            const detail = group.link_menu_detail.find(d => d.product_detail_fkid == detailFkid);
            const resolved = this.resolveProduct(detailFkid);
            groupSelection.link_menu_detail.push({
              linkmenu_detail_id: detail ? detail.linkmenu_detail_id : 0,
              product_detail_fkid: detailFkid,
              price_add: detail ? detail.price_add : 0,
              product_name: resolved ? resolved.name : 'Tambahan',
              photo: resolved ? resolved.photo : "",
              tax: resolved && resolved.tax ? resolved.tax.filter(t => t.tax_status === "permanent") : []
            });
          });
        }

        if (groupSelection.link_menu_detail.length > 0) {
          selectedGroups.push(groupSelection);
        }
      });
      this.$emit("confirm", selectedGroups);
    }
  }
};
</script>

<style scoped>
.link-menu-modal {
  --border-radius: 28px 28px 0 0;
}

.parent-info-card {
  display: flex;
  align-items: center;
  gap: 16px;
  background: #f8f9fa;
  padding: 14px;
  border-radius: 16px;
  margin-top: 16px;
  margin-bottom: 24px;
  border: 1px solid #eef0f2;
}

.parent-img {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  object-fit: cover;
}

.parent-text h3 {
  font-size: 1.1rem;
  font-weight: 700;
  color: #2d3436;
  margin: 0 0 4px 0;
}

.parent-price {
  font-size: 0.95rem;
  color: var(--primary-color, #8C1115);
  font-weight: 700;
  margin: 0;
}

.group-container {
  margin-bottom: 24px;
}

.group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 6px;
  border-bottom: 1px solid #f1f2f6;
}

.group-name {
  font-size: 1rem;
  font-weight: 700;
  color: #2d3436;
}

.group-badge {
  font-size: 0.75rem;
  color: var(--primary-color, #8C1115);
  background: rgba(0, 0, 0, 0.05);
  padding: 4px 10px;
  border-radius: 12px;
  font-weight: 600;
}

.options-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.option-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: #ffffff;
  border: 1.5px solid #edf2f7;
  border-radius: 16px;
  transition: all 0.2s ease;
  cursor: pointer;
}

.option-card.selected {
  border-color: var(--primary-color, #8C1115);
  background: rgba(0, 0, 0, 0.01);
}

.option-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.option-img {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  object-fit: cover;
}

.option-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.option-name {
  font-size: 0.9rem;
  font-weight: 600;
  color: #2d3436;
}

.option-price {
  font-size: 0.85rem;
  color: #718096;
  font-weight: 600;
}

.option-right {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Radio Indicator */
.radio-indicator {
  width: 20px;
  height: 20px;
  border: 2px solid #cbd5e0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.option-card.selected .radio-indicator {
  border-color: var(--primary-color, #8C1115);
}

.radio-inner {
  width: 10px;
  height: 10px;
  background: var(--primary-color, #8C1115);
  border-radius: 50%;
}

/* Checkbox Indicator */
.checkbox-indicator {
  width: 20px;
  height: 20px;
  border: 2px solid #cbd5e0;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.option-card.selected .checkbox-indicator {
  border-color: var(--primary-color, #8C1115);
  background: var(--primary-color, #8C1115);
}

.checkbox-indicator ion-icon {
  color: white;
  font-size: 0.9rem;
  font-weight: bold;
}

/* Sticky Footer */
.modern-footer {
  background: #ffffff;
  box-shadow: 0 -10px 25px rgba(0, 0, 0, 0.08);
  padding: 16px 20px calc(16px + var(--ion-safe-area-bottom));
}

.btn-main {
  --background: var(--primary-color, #8C1115);
  --color: #ffffff;
  --border-radius: 14px;
  --padding-top: 14px;
  --padding-bottom: 14px;
  font-weight: 700;
  margin: 0;
  height: 52px;
}
</style>
